/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies React=================
import {
  forwardRef,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// ==================Actions=================
import { setGreaterLat, setLessLat } from '../../../actions/site';

export default forwardRef((props, ref) => {
  // ==================HOOKS=================
  const dispatch = useDispatch();
  const greaterLat = useSelector((state) => state.site.filter.greaterLat);
  const lessLat = useSelector((state) => state.site.filter.lessLat);
  const gridRef = useRef();

  // Remove precedent filter and save new value selected by user
  const onInputBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(setGreaterLat(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('greaterThan', null);
      });
      return;
    }
    dispatch(setGreaterLat(Number(input.target.value)));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('greaterThan', input.target.value);
    });
  };

  const onInputLatBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(setLessLat(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('lessThan', null);
      });
      return;
    }
    dispatch(setLessLat(Number(input.target.value)));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('lessThan', input.target.value);
    });
  };

  // ==================Styles=================
  const style = {
    color: props.color,
    width: '100%',
    maxHeight: '24px',
    margin: 'auto',
    marginTop: '0.2em',
    border: '1px solid gray',
    borderRadius: '3px',
    display: 'block',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div
      style={containerStyle}
    >
      <input
        placeholder="greater than ..."
        id="greaterThanLat"
        ref={gridRef}
        value={greaterLat}
        style={style}
        type="number"
        onInput={onInputBoxChanged}
      />
      <input
        placeholder="less than ..."
        id="lessThanLat"
        ref={gridRef}
        value={lessLat}
        style={style}
        type="number"
        onInput={onInputLatBoxChanged}
      />
    </div>
  );
});
